export const APP_URL = "https://weight-monitor-23.preview.emergentagent.com";
export const TESTFLIGHT_URL = "https://testflight.apple.com/join/3pw9SFyd";
export const ANDROID_TEST_URL = "https://play.google.com/store/apps/details?id=app.emergent.weightmonitor23657219b3";
export const FRIDGE_VIDEO = "https://customer-assets.emergentagent.com/job_fit-preview-85/artifacts/wkc8f474_Mon%20film%2013_1.mp4";
export const LOGO_GREEN = "https://static.prod-images.emergentagent.com/jobs/f19b6a14-0036-48b4-acf8-894864ecc195/images/0da2219796608054dc99e6d23cc13bb7b6513528328addca814da47e13d97a42.jpeg";

// Real app screenshots provided by the user
const BASE = "https://customer-assets.emergentagent.com/job_fit-preview-85/artifacts";
export const SCREENS = {
  home: "https://customer-assets-agu9un31.emergentagent.net/job_fit-preview-85/artifacts/j876qpms_Screenshot_20260913_084444_JosFit%20energeia.webp",
  health: `${BASE}/vru9pui2_Screenshot_20260703_011318_JosFit%20energeia.jpg`,
  cycle: `${BASE}/e2txeze8_Screenshot_20260703_011325_JosFit%20energeia.jpg`,
  corps: `${BASE}/teqvnten_Screenshot_20260703_011334_JosFit%20energeia.jpg`,
  progress: `${BASE}/qqkjif82_Screenshot_20260703_011341_JosFit%20energeia.jpg`,
  bilanMetabolique: `${BASE}/vd8hbwot_Screenshot_20260703_022211_JosFit%20energeia.jpg`,
  bilanMois: `${BASE}/vuh5r42c_Screenshot_20260703_022222_JosFit%20energeia.jpg`,
  dupliquer: `${BASE}/dc6nq9uy_Screenshot_20260703_022230_JosFit%20energeia.jpg`,
  exportPdf: `${BASE}/4i68uat5_Screenshot_20260703_022243_JosFit%20energeia.jpg`,
  repasSurprise: `${BASE}/jf3e1xk2_Screenshot_20260703_022305_JosFit%20energeia.jpg`,
  recettes: `${BASE}/7j2ycsh6_Screenshot_20260703_022037_JosFit%20energeia.jpg`,
  journeeLuna: `${BASE}/hg8p8tgh_Screenshot_20260703_022051_JosFit%20energeia.jpg`,
  ajoutIntelligent: `${BASE}/qj127tbr_Screenshot_20260703_022059_JosFit%20energeia.jpg`,
  rechercheAliments: `${BASE}/y73wpd77_Screenshot_20260703_022134_JosFit%20energeia.jpg`,
};

const BASE2 = "https://customer-assets-agu9un31.emergentagent.net/job_fit-preview-85/artifacts";
export const COACH_SCREENS = {
  coachShare: `${BASE2}/v3k0m3bk_Screenshot_20260926_205222_JosFit%20energeia.webp`,
  coachHome: `${BASE2}/yvega2ht_Screenshot_20260913_084730_JosFit%20energeia.webp`,
  coachPrograms: `${BASE2}/cfzzq59y_Screenshot_20260913_084758_JosFit%20energeia.webp`,
  coachNutrition: `${BASE2}/lcpjm20p_Screenshot_20260913_084818_JosFit%20energeia.webp`,
  coachReminders: `${BASE2}/e962s30m_Screenshot_20260913_084828_JosFit%20energeia.webp`,
  coachExercise: `${BASE2}/u5bket2t_Screenshot_20260913_090738_JosFit%20energeia.webp`,
  coachRestTimer: `${BASE2}/dlsuoluh_Screenshot_20260913_090744_JosFit%20energeia.webp`,
};

export const ASSETS = {
  videoPoster:
    "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxneW0lMjB3b3Jrb3V0JTIwaW50ZW5zaXR5JTIwZGFya3xlbnwwfHx8YmxhY2t8MTc4MzAyMzU4OHww&ixlib=rb-4.1.0&q=85",
};
